<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="center-block" v-if="course === null">
          <div>
            <div class="alert alert-danger mb-0">
              Este curso não está disponível.<br />
              <p class="text-center">
                <a href="/cursos" class="btn mt-2">
                  <i class="fa fa-arrow-left" /> Voltar para os cursos</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", `CourseListPage`);
    this.loadCourse();
  },

  data() {
    return {
      profile: null,
      course: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadCourse() {
      this.$store.commit("setLoading", true);
      let courseId = this.$route.path.substring(7);
      try {
        let response = await AssistantManager.getCourse(courseId);
        if (response.course) {
          location.href = `/curso/${courseId}/${response.course.lastSeenClassId}`;
        } else {
          this.course = null;
          this.$store.commit("setActiveSection", `CourseNotFoundPage`);
          this.$store.commit("setActiveUser", response.assistant);
          this.$store.commit("setLoading", false);
        }
      } catch (error) {
        this.handleAPIError(error, `curso/${courseId}`);
      }
    },
  },
};
</script>
